import SicCodesMapping from "../../../mappings_dir/sic_codes.json";
import SicCodeAppetite from "../../../mappings_dir/sic_code_appetites.json";

export const SIC_CODES: { [key: string]: string } =
  SicCodesMapping.sic_codes as { [key: string]: string };

// Matches sic.py
export const isOutOfAppetiteSicCode = (code: string | null | undefined) => {
  if (!code) {
    return false;
  }

  if (
    !SicCodeAppetite.out_of_appetite_sic_codes.some((bad_code) =>
      code.startsWith(bad_code)
    )
  ) {
    return false;
  }

  return !SicCodeAppetite.in_appetite_overrides.some((bad_code) =>
    code.startsWith(bad_code)
  );
};

/**
 * Formats a SIC code into a display string.
 * e.g. "7213 (Linen Supply)" or just "7213" if no description found.
 */
export const formatSicDisplay = (
  sicCode: string | undefined | null
): string => {
  if (!sicCode) return "";
  const desc = SIC_CODES[sicCode];
  return desc ? `${sicCode} (${desc})` : sicCode;
};
